import React, { useState, useEffect } from "react";
import {
    Tabs,
    Tab,
    Typography,
    makeStyles,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Box,
    CircularProgress
} from "@material-ui/core";
import API from "../../../API";
import { PersonalInFormationForm } from "./PersonalInFormationForm";
import CustomQuestion from "./CustomQuestion";
import { NEW_CLIENT_FORM_VALIDATION_SCHEMA } from "../../../libs";
import deleteIcon from "../../../img/delete-icon.svg";
import classNames from "classnames";
import closeIcon from "../../../img/close-icon.svg";

const useStyles = makeStyles(theme => ({
    main: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    root: {
        maxWidth: "100%",
        marginTop: "40px",
        border: "1px solid #00000050",
        padding: "30px",
        borderRadius: "17px",
        background: "#fff"
    },
    heading: {
        fontSize: "22px",
        fontWeight: 700,
        textAlign: "center",
        marginBottom: "30px"
    },
    button: {
        position: "absolute",
        height: "fit-content",
        padding: "8px 10px",
        right: "10px",
        fontFamily: "Lato",
        width: "max-content",
        margin: "0 !important",
        lineHeight: "normal",
        top: "41px",
        backgroundColor: "#4d5ccc !important",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#4d5ccc !important"
        }
    },

    submit: {
        backgroundColor: "#4d5ccc",
        color: "#fff",
        minWidth: "120px",
        maxWidth: "120px",
        margin: "auto",
        marginBottom: "10px",
        "&:hover": {
            backgroundColor: "#4d5ccc !important"
        }
    },
    successMessage: {
        color: "green",
        marginBottom: "20px",
        textAlign: "center",
        maxWidth: "1000px",
        margin: "auto"
    },
    errorMessage: {
        // marginBottom: "20px",
        color: "#f44336 !important",
        margin: "auto"
    },
    codeField: {
        "& div>div": {
            margin: "16px 0 0 0 !important"
        }
    },
    tabsDiv: {
        "& div>div": {
            justifyContent: "space-around",
            backgroundColor: " #F0F0F0",
            maxWidth: "600px",
            margin: "auto",
            borderRadius: "12px"
        },
        "& button": {
            width: "100%",
            maxWidth: "300px",
            "&.Mui-selected": {
                color: "#FFF !important",
                position: "relative",
                zIndex: "1"
            }
        },
        "& span": {
            height: "100%",
            borderRadius: "12px 0 0 12px",
            clipPath: "polygon(1% 0, 100% 0%, 90% 100%, 0% 100%)"
        }
    },

    copyURL: {
        maxWidth: "1000px",
        margin: "auto",
        "&>div": {
            display: "flex",
            justifyContent: "center",
            marginBottom: "40px",
            alignItems: "center",
            height: "max-content",
            columnGap: "20px",
            width: "100%",
            "& .Url-text": {
                borderRadius: "12px",
                border: "1px solid #E9EAEB",
                background: "#FFF",
                width: "100%",
                height: "100%",
                // marginTop: "10px",
                whiteSpace: "nowrap",
                overflowX: "auto",
                scrollbarWidth: " none",
                "& p": {
                    padding: "10px",
                    color: " rgba(0, 0, 0, 0.40)",
                    display: "inline-block"
                }
            }
        },
        "& button": {
            minWidth: "136px",
            borderRadius: "12px",
            background: "#4D5CCC",
            padding: "10px",
            color: "#FFF",
            "&:hover": {
                backgroundColor: "#4d5ccc !important"
            }
        }
    },
    mainDiv: {
        padding: "60px"
    },
    activeTabsContainer: {
        "& span": {
            borderRadius: "0px 12px  12px 0px",
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 10% 100%)"
        }
    },
    dialogTitle: {
        padding: "0px",
        fontSize: "18px",
        fontWeight: "600",
        color: "#181D27",
        position: "relative",
        paddingTop: "60px"
    },
    dialogDescription: {
        fontSize: "14px",
        color: "#000000A6",
        lineHeight: "20px",
        marginBottom: "0px"
    },
    dialogCommonButton: {
        fontSize: "16px",
        textTransform: "initial",
        fontWeight: "400",
        boxShadow: "0px 1px 2px 0px rgba(10, 13, 18, 0.05)",
        borderRadius: "5px",
        padding: "10px 10px",
        flex: "1"
    },
    closeButton: {
        color: "#414651",
        border: "1px solid #D5D7DA",
        backgroundColor: "white",
        "&:hover": {
            color: "#414651",
            border: "1px solid #D5D7DA",
            backgroundColor: "white"
        }
    },
    deactivateButton: {
        backgroundColor: "#D92D20",
        border: "1px solid #D92D20",
        color: "white",
        "&:hover": {
            backgroundColor: "#D92D20",
            border: "1px solid #D92D20",
            color: "white"
        }
    },
    dialogButtonBox: {
        display: "flex",
        flexWrap: "wrap",
        gap: "10px",
        width: "100%"
    },
    dialogActionButton: {
        padding: "0px !important",
        marginTop: "50px"
    },
    dialogContent: {
        padding: "0px",
        marginTop: "15px"
    },
    closeBox: {
        top: "0px",
        right: "0px",
        position: "absolute",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    dialogPaper: {
        backgroundColor: "white",
        padding: "30px",
        width: "100%",
        margin: "15px",
        borderRadius: "15px"
    },
    wave: {
        position: "absolute",
        height: "110px",
        width: "110px",
        background: "rgb(116 0 0 / 30%)",
        opacity: 0,
        borderRadius: "50%",
        margin: "auto",
        top: "0px",
        left: "0px",
        right: "0px",
        bottom: "0px",
        zIndex: -1,
        animation: `$waves 2s ease-in-out infinite`
    },
    "@keyframes waves": {
        "0%": { transform: "scale(0.2, 0.2)", opacity: 0 },
        "50%": { opacity: 0.9 },
        "100%": { transform: "scale(0.7, 0.7)", opacity: 0 }
    },
    wave1: {
        background: "#FEE4E2",
        animationDelay: "0s"
    },
    wave2: {
        background: "#FEF3F2",
        animationDelay: "1s"
    },
    wave3: {
        background: "#d92d204f",
        animationDelay: "2s"
    },
    waveImage: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    mainWave: {
        position: "absolute",
        bottom: "0px",
        top: "-45px",
        margin: "auto",
        left: "-30px",
        zIndex: "999999",
        height: "110px",
        width: "110px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "transform 0.5s ease-in-out, opacity 0.5s ease-in-out"
    },
    "@media (max-width:768px) ": {
        mainDiv: {
            padding: "60px 30px"
        }
    },

    "@media (max-width:680px) ": {
        tabsDiv: {
            "& div>div": {
                maxWidth: "440px"
            },
            "& button": {
                maxWidth: "220px"
            }
        }
    },
    "@media (max-width:520px) ": {
        mainDiv: {
            padding: "60px 16px"
        },
        tabsDiv: {
            "& div>div": {
                maxWidth: "320px"
            },
            "& button": {
                maxWidth: "160px"
            }
        },
        root: {
            padding: "15px "
        }
    },
    "@media only screen and (max-width: 450px)": {
        dialogPaper: {
            padding: "15px",
            margin: "15px"
        }
    }
}));

export const NewClientForm = props => {
    props.setLocationName();
    const classes = useStyles();
    const [therapist, setTherapist] = useState({});
    const [questions, setQuestions] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [clientFormLink, setClientFormLink] = useState("");
    const [err, setErr] = useState({});
    const [unsavedQuestions, setUnsavedQuestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingStates, setLoadingStates] = useState({});

    const proxyUrl = "https://handsonbooking-test2.azurewebsites.net/patientPersonalInformationForm";

    const [tabIndex, setTabIndex] = useState(0);

    const [clientData, setClientData] = useState({
        nameFirst: "",
        nameLast: "",
        address: "",
        town: "",
        post: "",
        email: "",
        CPRLast4Digit: "",
        CPR6Digit: "",
        phonePrivate: "",
        phoneWork: "",
        phoneRelative: "",
        civilStatus: "",
        sex: "",
        education: "",
        children: "",
        doctor: "",
        otherTreater: "",
        CPR: ""
    });

    const [copied, setCopied] = useState(false);
    const [sucMes, setSucMes] = useState("");
    const [errMes, setErrMes] = useState("");
    const [errors, setErrors] = useState({});
    const [deleteModal, setShowDeleteModal] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [deleteId, setDeleteId] = useState("");

    // const searchParams = new URLSearchParams(location.search);
    // const clientId = searchParams.get("clientId");
    // const therapistId = searchParams.get("therapistId");
    useEffect(() => {
        /**
         * Retrieves the therapist data and updates the state.
         * @async
         * @memberof NewClientForm
         * @returns {Promise<void>}
         */
        const getTherapist = async () => {
            const data = await API.getTherapist();
            setTherapist(data);
        };

        getTherapist();
    }, []);

    /**
     * Fetches all client form fields from the server and updates the list of questions.
     * Includes both saved and unsaved questions.
     *
     * @throws Will log an error if the questions cannot be fetched.
     */
    const fetchQuestions = async () => {
        try {
            // setLoading(true);
            const savedQuestions = await API.getAllClientFormFields();
            setQuestions([...unsavedQuestions, ...savedQuestions]); // Keep unsaved fields
        } catch (error) {
            console.error("Error fetching questions:", error);
        }
        // setLoading(false);
    };
    useEffect(() => {
        fetchQuestions();
    }, []);

    /**
     * Asynchronously fetches the last 4 digits of the CPR number from the API
     * and updates the client data in both localStorage and the state.
     *
     * If successful, the function retrieves existing client data from localStorage,
     * updates the CPRLast4Digit with the fetched result, and stores the updated data
     * back in localStorage along with a timestamp. The client data state is also updated.
     *
     * @async
     * @returns {Promise<void>} - A promise that resolves when the operation is complete.
     */

    const get4lastDigitCPR = async () => {
        var result = await API.get4LastDigitCPR();
        if (result) {
            // Retrieve existing data from localStorage
            const storedData = JSON.parse(localStorage.getItem("clientData"));

            // Extract previous clientData or use an empty object
            const prevData = storedData?.value || {};

            // Update only CPRLast4Digit
            const updatedData = {
                ...prevData,
                CPRLast4Digit: result.lastDigit
            };

            // Store updated data in localStorage
            const dataToStore = {
                value: updatedData,
                timestamp: new Date().getTime() // Store current time in milliseconds
            };
            localStorage.setItem("clientData", JSON.stringify(dataToStore));

            // Update state
            setClientData(updatedData);
        }
    };

    // const get4lastDigitCPR = async () => {
    //     var result = await API.get4LastDigitCPR();
    //     if (result) {
    //         setClientData(prevData => ({
    //             ...prevData,
    //             CPRLast4Digit: result.lastDigit
    //         }));
    //     }
    // };

    /**
     * Generates a new question and adds it to the top of the questions list.
     * Keeps a copy of the unsaved question in a separate state.
     */
    const addQuestion = () => {
        const newId = Date.now(); // Generate once and reuse
        const newQuestion = {
            id: newId,
            fieldName: "",
            fieldType: "text",
            isRequired: false,
            isNew: true,
            isSave: true
        };
        setQuestions(prev => [newQuestion, ...prev]);
        setUnsavedQuestions(prev => [newQuestion, ...prev]); // Keep unsaved fields locally
    };

    const removeQuestion = id => {
        setQuestions(prev => prev.filter(q => q.id !== id));
        setUnsavedQuestions(prev => prev.filter(q => q.id !== id)); // Remove from unsaved list
    };

    /**
     * Updates a question in the state with new values
     * @param {number} id - The id of the question to update
     * @param {string} field - The field to update ('fieldName' or 'fieldType')
     * @param {string|boolean} value - The new value for the field
     */
    const handleChange = (id, field, value) => {
        setQuestions(prev => prev.map(q => (q.id === id ? { ...q, [field]: value } : q)));

        // Remove error when user starts typing
        setErr(prev => {
            const newErrors = { ...prev };
            if (field === "fieldName" && value.trim()) {
                delete newErrors[id]; // Remove the error for this field
            }
            return newErrors;
        });
    };

    /**
     * Saves a question to the client form fields.
     * Validates that the question name is not empty before saving.
     * Updates the list of questions with saved and unsaved questions.
     *
     * @param {number} id - The unique identifier of the question.
     * @param {string} name - The name of the question.
     * @param {string} type - The type of the question (e.g., text, number).
     *
     * @throws Will log an error if the question cannot be saved.
     */

    const saveQuestion = async (id, name, type, isRequired) => {
        try {
            setLoadingStates(prev => ({ ...prev, [id]: true })); // Start loader for specific question

            const question = questions.find(q => q.id === id);
            // Validate if name (fieldName) is empty
            if (!question || !question.fieldName.trim()) {
                setErr(prev => ({ ...prev, [id]: "Spørgsmålets navn må ikke være tomt!" }));
                setLoadingStates(prev => ({ ...prev, [id]: false }));
                return;
            }

            // Clear error if validation passes
            setErr(prev => ({ ...prev, [id]: "" }));
            const response = await API.addClientFormFields(name, type, isRequired);
            if (response.length > 0) {
                const updatedQuestions = await API.getAllClientFormFields();
                // Merge saved fields with unsaved ones
                setQuestions([
                    ...unsavedQuestions.filter(q => q.id !== id), // Keep remaining unsaved questions first
                    ...updatedQuestions // Then add saved questions
                ]);
                // setQuestions([...updatedQuestions, ...unsavedQuestions.filter(q => q.id !== id)]);
                // Remove saved question from unsaved list
                setUnsavedQuestions(prev => prev.filter(q => q.id !== id));
                // setQuestions(updatedQuestions);
            }
            setLoadingStates(prev => ({ ...prev, [id]: false })); // Stop loader after saving
        } catch (err) {
            setLoadingStates(prev => ({ ...prev, [id]: false })); // Stop loader on error
            console.error("Error saving question:", err);
        }
    };

    const handleUpdateQuestion = async (id, name, type, isRequired) => {
        try {
            const question = questions.find(q => q.id === id);
            // Validate if name (fieldName) is empty
            if (!question || !question.fieldName.trim()) {
                setErr(prev => ({ ...prev, [id]: "Spørgsmålets navn må ikke være tomt!" }));
                return;
            }

            // Clear error if validation passes
            setErr(prev => ({ ...prev, [id]: "" }));
            const response = await API.updateClientFormFields(id, name, type, isRequired);
            // if (response.length > 0) {
            const updatedQuestions = await API.getAllClientFormFields();
            // Merge saved fields with unsaved ones
            setQuestions([...updatedQuestions, ...unsavedQuestions.filter(q => q.id !== id)]);
            // Remove saved question from unsaved list
            setUnsavedQuestions(prev => prev.filter(q => q.id !== id));
            // setQuestions(updatedQuestions);
            // }
        } catch (err) {
            console.error("Error saving question:", err);
        }
    };

    const editQuestion = id => {
        setQuestions(prev => prev.map(q => (q.id === id ? { ...q, isEditing: true } : q)));
    };

    /**
     * Handle tab change event.
     * @param {object} _event The event that triggered the change.
     * @param {number} newValue The new value of the selected tab.
     */
    const handleTabChange = (_event, newValue) => {
        setTabIndex(newValue);
    };

    const handleCheckboxChange = id => {
        setSelectedIds(prev => (prev.includes(id) ? prev.filter(qId => qId !== id) : [...prev, id]));
    };

    useEffect(() => {
        let url = `${process.env.REACT_APP_CLIENT_FORM_PAGE}?therapistID=${therapist.id}`;

        if (selectedIds.length > 0) {
            const idsString = selectedIds.join(","); // Convert array to comma-separated string
            url += `&ids=${idsString}`; // Append only if selectedIds is not empty
        }
        setClientFormLink(url);
    }, [selectedIds, therapist.id]);

    /**
     * Copies the shop URL to the clipboard. The URL is generated based on
     * the therapist ID and the selected client IDs.
     *
     * @param {number} therapistID - The ID of the therapist.
     * @param {number[]} selectedIds - The IDs of the selected clients.
     */
    const onCopyShopUrl = (therapistID, selectedIds) => {
        let url = `${process.env.REACT_APP_CLIENT_FORM_PAGE}?therapistID=${therapistID}`;

        if (selectedIds.length > 0) {
            const idsString = selectedIds.join(","); // Convert array to comma-separated string
            url += `&ids=${idsString}`; // Append only if selectedIds is not empty
        }

        navigator.clipboard
            .writeText(url)
            .then(() => {
                setCopied(true);
            })
            .catch(err => {
                console.error("Failed to copy:", err);
            });
    };

    useEffect(() => {
        if (copied) {
            const timer = setTimeout(() => {
                setCopied(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [copied]);

    const changeValue = type => async value => {
        try {
            if (type === "email") {
                await NEW_CLIENT_FORM_VALIDATION_SCHEMA.validateAt(type, { [type]: value });
            }
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[type]; // Remove error if input is valid
                return newErrors;
            });
        } catch (err) {
            setErrors(prevErrors => ({
                ...prevErrors,
                [type]: err.message // Set specific error message
            }));
        }
        setClientData(prevData => {
            const updatedData = { ...prevData, [type]: value };

            // Store updated data in localStorage with a timestamp
            const dataToStore = {
                value: updatedData,
                timestamp: new Date().getTime() // Store current time in milliseconds
            };
            localStorage.setItem("clientData", JSON.stringify(dataToStore));

            return updatedData;
        });
    };

    useEffect(() => {
        const storedData = localStorage.getItem("clientData");
        if (storedData) {
            const { value, timestamp } = JSON.parse(storedData);
            const now = new Date().getTime();
            const expiryTime = 20 * 60 * 1000; // 20 minutes in milliseconds

            if (now - timestamp < expiryTime) {
                setClientData(value); // Load valid data
            } else {
                localStorage.removeItem("clientData"); // Remove expired data
            }
        }
    }, []);

    /**
     * Handles sending the personal information form data to the API.
     * Validates the data using Yup and then sends a request to the API to update the client.
     * If the request is successful, sets a success message.
     * If the request fails, sets an error message.
     * If the validation fails, sets a map of error messages.
     */
    const sendMail = async () => {
        try {
            setLoading(true);
            // Validate clientData using Yup
            await NEW_CLIENT_FORM_VALIDATION_SCHEMA.validate({ email: clientData.email }, { abortEarly: false });
            const client = {
                ...clientData,
                CPR: clientData.CPR6Digit + clientData.CPRLast4Digit
            };

            const success = await API.addClient(client, selectedIds, therapist.id);
            setLoading(false);
            setSucMes("e-mail er blevet sendt!");

            localStorage.removeItem("clientData");
            setClientData({
                nameFirst: "",
                nameLast: "",
                address: "",
                town: "",
                post: "",
                email: "",
                CPRLast4Digit: "",
                CPR6Digit: "",
                phonePrivate: "",
                phoneWork: "",
                phoneRelative: "",
                civilStatus: "",
                sex: "",
                education: "",
                children: "",
                doctor: "",
                otherTreater: ""
            });
            setSelectedIds([]);
        } catch (error) {
            if (error.name === "ValidationError") {
                // Collect validation errors and update state
                const errors = {};
                error.inner.forEach(err => {
                    errors[err.path] = err.message;
                });
                setErrors(errors);
            } else {
                // Handle API or other errors
                setErrMes(error);
            }
            setLoading(false);
        }
    };

    const deleteQuestion = async id => {
        try {
            setIsDeleteLoading(true);
            const response = await API.deleteClientFormFields(deleteId);
            // if (response.length > 0) {
            fetchQuestions();
            setSucMes("spørgsmålet blev slettet!");
        } catch (err) {
            setErr(err);
            console.error("Error saving question:", err);
        }
        setIsDeleteLoading(false);
        setShowDeleteModal(false);

        // const updatedQuestions = questions.filter(question => question.id !== id);
        // setQuestions(updatedQuestions);
    };

    setTimeout(() => {
        setErr("");
        setSucMes("");
    }, 7000);

    return (
        <div className={classes.mainDiv}>
            {/* Tabs Navigation */}

            <div className={classes.copyURL}>
                <Typography>Formular link</Typography>
                <div>
                    <div className="Url-text">
                        <Typography>{clientFormLink}</Typography>
                    </div>
                    <div>
                        <Button variant="contained" onClick={() => onCopyShopUrl(therapist.id, selectedIds)}>
                            {copied ? "Kopieret!" : "kopi"}
                        </Button>
                    </div>
                </div>
            </div>

            {sucMes && (
                <Typography variant="body1" className={classes.successMessage}>
                    {sucMes}
                </Typography>
            )}
            {errMes && (
                <Typography variant="h6" className={classes.errorMessage}>
                    {errMes}
                </Typography>
            )}
            <Tabs
                className={`${classes.tabsDiv} ${tabIndex === 1 ? classes.activeTabsContainer : ""}`}
                value={tabIndex}
                indicatorColor="primary"
                TabIndicatorProps={{
                    style: {
                        backgroundColor: "#4d5ccc"
                    }
                }}
                textColor="primary"
                onChange={handleTabChange}
                aria-label="Custom Questions Tabs">
                <Tab label="Personlige oplysninger" className={`${tabIndex === 0 ? classes.activeTab : ""}`} />
                <Tab label="Spørgsmål" className={`${tabIndex === 1 ? classes.activeTab : ""}`} />
            </Tabs>

            {/* Tab Content */}
            {tabIndex === 0 && (
                // <Box p={3} maxWidth="lg" mx="auto" bgcolor="white" borderRadius={4} boxShadow={3}>
                //     <h2 style={{ fontSize: "1.25rem", fontWeight: "bold", marginBottom: "1rem" }}>
                //         Personal Information
                //     </h2>
                //     <Button variant="contained" color="primary" onClick={addQuestion} style={{ marginBottom: "1rem" }}>
                //         + Add Question
                //     </Button>
                // </Box>

                <PersonalInFormationForm
                    classes={classes}
                    clientData={clientData}
                    changeValue={changeValue}
                    get4lastDigitCPR={get4lastDigitCPR}
                    setClientData={setClientData}
                    // onSave={onSave}
                    handleTabChange={handleTabChange}
                    errors={errors}
                    isPatient={false}
                />
            )}

            {tabIndex === 1 && (
                <CustomQuestion
                    addQuestion={addQuestion}
                    questions={questions}
                    handleChange={handleChange}
                    saveQuestion={saveQuestion}
                    removeQuestion={removeQuestion}
                    selectedIds={selectedIds}
                    handleCheckboxChange={handleCheckboxChange}
                    editQuestion={editQuestion}
                    sendMail={sendMail}
                    err={err}
                    errors={errors}
                    handleUpdateQuestion={handleUpdateQuestion}
                    setDeleteId={setDeleteId}
                    setShowDeleteModal={setShowDeleteModal}
                    loadingStates={loadingStates}
                    loading={loading}
                />
            )}
            <Dialog
                open={deleteModal}
                onClose={() => setShowDeleteModal(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth={true}
                className={classes.dialogBox}
                PaperProps={{
                    classes: { root: classes.dialogPaper }
                }}>
                <DialogTitle className={classes.dialogTitle} id="alert-dialog-title">
                    <Box className={classes.mainWave}>
                        <Box className={classes.waveImage}>
                            <img src={deleteIcon} alt="close-icon" />
                        </Box>
                        <Box sx={{ animationDelay: "0s" }} className={classNames(classes.wave, classes.wave1)}></Box>
                        <Box sx={{ animationDelay: "1s" }} className={classNames(classes.wave, classes.wave2)}></Box>
                        <Box sx={{ animationDelay: "2s" }} className={classNames(classes.wave, classes.wave3)}></Box>
                    </Box>
                    Slet spørgsmål
                    <Box className={classes.closeBox} onClick={() => setShowDeleteModal(false)}>
                        <img src={closeIcon} alt="close-icon" />
                    </Box>
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <DialogContentText id="alert-dialog-description" className={classes.dialogDescription}>
                        Er du sikker på, at du vil slette dette spørgsmål?
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.dialogActionButton}>
                    <Box className={classes.dialogButtonBox}>
                        <Button
                            onClick={() => setShowDeleteModal(false)}
                            color="primary"
                            autoFocus
                            className={classNames(
                                classes.closeButton,
                                classes.dialogCommonButton,
                                classes.closeButton,
                                classes.dialogCommonButton
                            )}>
                            Luk
                        </Button>
                        <Button
                            onClick={deleteQuestion}
                            color="primary"
                            autoFocus
                            disabled={isDeleteLoading}
                            className={classNames(
                                classes.deactivateButton,
                                classes.dialogCommonButton,
                                classes.customButton,
                                classes.customCommonButton
                            )}>
                            Slet {isDeleteLoading && <CircularProgress size={20} color="inherit" />}
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </div>
    );
};
